// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"d2d963ed","70":"ed285b9a","75":"79d8e596","85":"297a3c76","238":"ebcf339b","389":"38958068","448":"bb335ff8","743":"afe9b3e8","818":"cc7ae94b","892":"fb01ca8e","899":"29169623"}[chunkId] + ".chunk.js";
};